import BssoPermissions from "components/LM/Bsso/Permissions";
import K2Api from 'lib/ajax/K2Api';
import { useState } from "react";
import { Button } from "@launchmetrics/lm-ui";

import { Loader, ToastService } from "@launchmetrics/lm-ui";
import './CrawlingSwitch.scss';

const K2_API = new K2Api();

function CrawlingSwitch(props) {
	const { voiceId, profileId, isOrphan, type, className } = props;
	const [checked, setChecked] = useState(props.checked);
	const [loading, setLoading] = useState(false);

	const showLoader = () => {
		if (loading) {
			return <Loader size={20}/>;
		}
	}

	const toggleCrawling = async (url) => {
		setLoading(true);
		const newCheckedState = !checked;
		try {
			const httpMethod = newCheckedState ? "put" : "delete";
			await K2_API[httpMethod](url);
			setChecked(newCheckedState);
		} catch (error) {
			ToastService.show({
				id: "toggle-crawling-failed",
				title: "Failed to toggle the Crawling",
				type: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	const toggleCrawlingOrphan = () => {
		toggleCrawling(`/socialmedia/${type}/crawling/${profileId}`);
	};

	const toggleCrawlingSocialmedia = () => {
		toggleCrawling(`/voices/${voiceId}/socialmedia/${type}/crawling/${profileId}`);
	};

	let icon, text;
	if (checked) {
		icon = <span className="dot green"></span>;
		text = 'Set inactive';
	} else {
		icon = <span className="dot red"></span>;
		text = 'Set active';
	}

	return (
		<BssoPermissions permissions={isOrphan ? ['orphan_crawling'] : ['voices', 'edit']}>
			<Button className={`${className} crawling-switch`} variant="tertiary" size="small" disabled={loading} onClick={isOrphan ? toggleCrawlingOrphan : toggleCrawlingSocialmedia}>
				{icon} {text} {showLoader()}
			</Button>
		</BssoPermissions>
	);
}

export default CrawlingSwitch;
